/* eslint-disable eag/match-named-export -- Pre-existing grab-bag file with several exports */
import {GetApiMakeModelWithMakeApiResponse} from '@dms/api/shared';

export const makeModelWithSkodaMakesResponseMock = [
  {
    default_label: '\u0160koda',
    make: 'MAKE_SKODA',
    models: [
      {
        default_label: 'Octavia',
        model: 'MAKE_SKODA-MODELFAMILY_OCTAVIA',
        model_group: null,
      },
      {
        default_label: 'Pick-Up',
        model: 'MAKE_SKODA-MODELFAMILY_PICK_UP',
        model_group: null,
      },
      {
        default_label: 'Rapid',
        model: 'MAKE_SKODA-MODELFAMILY_RAPID',
        model_group: null,
      },
    ],
    vehicle_type: 'VEHICLETYPE_PASSENGER_CAR',
  },
];

export const makeModelWithBMWMakesResponseMock: GetApiMakeModelWithMakeApiResponse = [
  {
    default_label: 'BMW',
    make: 'MAKE_BMW',
    models: [
      {
        default_label: '330',
        model: 'MAKE_BMW-MODELFAMILY_330',
        model_group: {
          default_label: 'Series 3',
          group: 'MAKE_BMW-MODELFAMILYGROUP_SERIES_3',
        },
      },
      {
        default_label: '330 Gran Turismo',
        model: 'MAKE_BMW-MODELFAMILY_330_GRAN_TURISMO',
        model_group: {
          default_label: 'Series 3',
          group: 'MAKE_BMW-MODELFAMILYGROUP_SERIES_3',
        },
      },
      {
        default_label: '335',
        model: 'MAKE_BMW-MODELFAMILY_335',
        model_group: {
          default_label: 'Series 3',
          group: 'MAKE_BMW-MODELFAMILYGROUP_SERIES_3',
        },
      },
      {
        default_label: '335 Gran Turismo',
        model: 'MAKE_BMW-MODELFAMILY_335_GRAN_TURISMO',
        model_group: {
          default_label: 'Series 3',
          group: 'MAKE_BMW-MODELFAMILYGROUP_SERIES_3',
        },
      },
      {
        default_label: '340',
        model: 'MAKE_BMW-MODELFAMILY_340',
        model_group: {
          default_label: 'Series 3',
          group: 'MAKE_BMW-MODELFAMILYGROUP_SERIES_3',
        },
      },
      {
        default_label: '340 Gran Turismo',
        model: 'MAKE_BMW-MODELFAMILY_340_GRAN_TURISMO',
        model_group: {
          default_label: 'Series 3',
          group: 'MAKE_BMW-MODELFAMILYGROUP_SERIES_3',
        },
      },
      {
        default_label: 'M340i',
        model: 'MAKE_BMW-MODELFAMILY_M340I',
        model_group: {
          default_label: 'Series 3',
          group: 'MAKE_BMW-MODELFAMILYGROUP_SERIES_3',
        },
      },
      {
        default_label: 'M3',
        model: 'MAKE_BMW-MODELFAMILY_M3',
        model_group: {
          default_label: 'Series 3',
          group: 'MAKE_BMW-MODELFAMILYGROUP_SERIES_3',
        },
      },
      {
        default_label: 'ActiveHybrid 3 ',
        model: 'MAKE_BMW-MODELFAMILY_ACTIVEHYBRID_3',
        model_group: {
          default_label: 'Series 3',
          group: 'MAKE_BMW-MODELFAMILYGROUP_SERIES_3',
        },
      },
      {
        default_label: '418',
        model: 'MAKE_BMW-MODELFAMILY_418',
        model_group: {
          default_label: 'Series 4',
          group: 'MAKE_BMW-MODELFAMILYGROUP_SERIES_4',
        },
      },
      {
        default_label: '418 Gran Coup\u00e9',
        model: 'MAKE_BMW-MODELFAMILY_418_GRAN_COUPE',
        model_group: {
          default_label: 'Series 4',
          group: 'MAKE_BMW-MODELFAMILYGROUP_SERIES_4',
        },
      },
      {
        default_label: '420',
        model: 'MAKE_BMW-MODELFAMILY_420',
        model_group: {
          default_label: 'Series 4',
          group: 'MAKE_BMW-MODELFAMILYGROUP_SERIES_4',
        },
      },
      {
        default_label: '420 Gran Coup\u00e9',
        model: 'MAKE_BMW-MODELFAMILY_420_GRAN_COUPE',
        model_group: {
          default_label: 'Series 4',
          group: 'MAKE_BMW-MODELFAMILYGROUP_SERIES_4',
        },
      },
      {
        default_label: '425',
        model: 'MAKE_BMW-MODELFAMILY_425',
        model_group: {
          default_label: 'Series 4',
          group: 'MAKE_BMW-MODELFAMILYGROUP_SERIES_4',
        },
      },
      {
        default_label: '425 Gran Coup\u00e9',
        model: 'MAKE_BMW-MODELFAMILY_425_GRAN_COUPE',
        model_group: {
          default_label: 'Series 4',
          group: 'MAKE_BMW-MODELFAMILYGROUP_SERIES_4',
        },
      },
      {
        default_label: '428',
        model: 'MAKE_BMW-MODELFAMILY_428',
        model_group: {
          default_label: 'Series 4',
          group: 'MAKE_BMW-MODELFAMILYGROUP_SERIES_4',
        },
      },
      {
        default_label: '428 Gran Coup\u00e9',
        model: 'MAKE_BMW-MODELFAMILY_428_GRAN_COUPE',
        model_group: {
          default_label: 'Series 4',
          group: 'MAKE_BMW-MODELFAMILYGROUP_SERIES_4',
        },
      },
      {
        default_label: '430',
        model: 'MAKE_BMW-MODELFAMILY_430',
        model_group: {
          default_label: 'Series 4',
          group: 'MAKE_BMW-MODELFAMILYGROUP_SERIES_4',
        },
      },
      {
        default_label: '430 Gran Coup\u00e9',
        model: 'MAKE_BMW-MODELFAMILY_430_GRAN_COUPE',
        model_group: {
          default_label: 'Series 4',
          group: 'MAKE_BMW-MODELFAMILYGROUP_SERIES_4',
        },
      },
      {
        default_label: '435',
        model: 'MAKE_BMW-MODELFAMILY_435',
        model_group: {
          default_label: 'Series 4',
          group: 'MAKE_BMW-MODELFAMILYGROUP_SERIES_4',
        },
      },
      {
        default_label: '435 Gran Coup\u00e9',
        model: 'MAKE_BMW-MODELFAMILY_435_GRAN_COUPE',
        model_group: {
          default_label: 'Series 4',
          group: 'MAKE_BMW-MODELFAMILYGROUP_SERIES_4',
        },
      },
      {
        default_label: '440',
        model: 'MAKE_BMW-MODELFAMILY_440',
        model_group: {
          default_label: 'Series 4',
          group: 'MAKE_BMW-MODELFAMILYGROUP_SERIES_4',
        },
      },
      {
        default_label: '440 Gran Coup\u00e9',
        model: 'MAKE_BMW-MODELFAMILY_440_GRAN_COUPE',
        model_group: {
          default_label: 'Series 4',
          group: 'MAKE_BMW-MODELFAMILYGROUP_SERIES_4',
        },
      },
      {
        default_label: 'M4',
        model: 'MAKE_BMW-MODELFAMILY_M4',
        model_group: {
          default_label: 'Series 4',
          group: 'MAKE_BMW-MODELFAMILYGROUP_SERIES_4',
        },
      },
      {
        default_label: '518',
        model: 'MAKE_BMW-MODELFAMILY_518',
        model_group: {
          default_label: 'Series 5',
          group: 'MAKE_BMW-MODELFAMILYGROUP_SERIES_5',
        },
      },
      {
        default_label: '520',
        model: 'MAKE_BMW-MODELFAMILY_520',
        model_group: {
          default_label: 'Series 5',
          group: 'MAKE_BMW-MODELFAMILYGROUP_SERIES_5',
        },
      },
      {
        default_label: '520 Gran Turismo',
        model: 'MAKE_BMW-MODELFAMILY_520_GRAN_TURISMO',
        model_group: {
          default_label: 'Series 5',
          group: 'MAKE_BMW-MODELFAMILYGROUP_SERIES_5',
        },
      },
      {
        default_label: '523',
        model: 'MAKE_BMW-MODELFAMILY_523',
        model_group: {
          default_label: 'Series 5',
          group: 'MAKE_BMW-MODELFAMILYGROUP_SERIES_5',
        },
      },
      {
        default_label: '524',
        model: 'MAKE_BMW-MODELFAMILY_524',
        model_group: {
          default_label: 'Series 5',
          group: 'MAKE_BMW-MODELFAMILYGROUP_SERIES_5',
        },
      },
      {
        default_label: '525',
        model: 'MAKE_BMW-MODELFAMILY_525',
        model_group: {
          default_label: 'Series 5',
          group: 'MAKE_BMW-MODELFAMILYGROUP_SERIES_5',
        },
      },
      {
        default_label: '528',
        model: 'MAKE_BMW-MODELFAMILY_528',
        model_group: {
          default_label: 'Series 5',
          group: 'MAKE_BMW-MODELFAMILYGROUP_SERIES_5',
        },
      },
      {
        default_label: '530',
        model: 'MAKE_BMW-MODELFAMILY_530',
        model_group: {
          default_label: 'Series 5',
          group: 'MAKE_BMW-MODELFAMILYGROUP_SERIES_5',
        },
      },
      {
        default_label: '530 Gran Turismo',
        model: 'MAKE_BMW-MODELFAMILY_530_GRAN_TURISMO',
        model_group: {
          default_label: 'Series 5',
          group: 'MAKE_BMW-MODELFAMILYGROUP_SERIES_5',
        },
      },
      {
        default_label: '535',
        model: 'MAKE_BMW-MODELFAMILY_535',
        model_group: {
          default_label: 'Series 5',
          group: 'MAKE_BMW-MODELFAMILYGROUP_SERIES_5',
        },
      },
      {
        default_label: '535 Gran Turismo',
        model: 'MAKE_BMW-MODELFAMILY_535_GRAN_TURISMO',
        model_group: {
          default_label: 'Series 5',
          group: 'MAKE_BMW-MODELFAMILYGROUP_SERIES_5',
        },
      },
      {
        default_label: '540',
        model: 'MAKE_BMW-MODELFAMILY_540',
        model_group: {
          default_label: 'Series 5',
          group: 'MAKE_BMW-MODELFAMILYGROUP_SERIES_5',
        },
      },
      {
        default_label: '545',
        model: 'MAKE_BMW-MODELFAMILY_545',
        model_group: {
          default_label: 'Series 5',
          group: 'MAKE_BMW-MODELFAMILYGROUP_SERIES_5',
        },
      },
      {
        default_label: '550',
        model: 'MAKE_BMW-MODELFAMILY_550',
        model_group: {
          default_label: 'Series 5',
          group: 'MAKE_BMW-MODELFAMILYGROUP_SERIES_5',
        },
      },
      {
        default_label: '550 Gran Turismo',
        model: 'MAKE_BMW-MODELFAMILY_550_GRAN_TURISMO',
        model_group: {
          default_label: 'Series 5',
          group: 'MAKE_BMW-MODELFAMILYGROUP_SERIES_5',
        },
      },
      {
        default_label: 'M550',
        model: 'MAKE_BMW-MODELFAMILY_M550',
        model_group: {
          default_label: 'Series 5',
          group: 'MAKE_BMW-MODELFAMILYGROUP_SERIES_5',
        },
      },
      {
        default_label: 'M5',
        model: 'MAKE_BMW-MODELFAMILY_M5',
        model_group: {
          default_label: 'Series 5',
          group: 'MAKE_BMW-MODELFAMILYGROUP_SERIES_5',
        },
      },
      {
        default_label: 'ActiveHybrid 5',
        model: 'MAKE_BMW-MODELFAMILY_ACTIVEHYBRID_5',
        model_group: {
          default_label: 'Series 5',
          group: 'MAKE_BMW-MODELFAMILYGROUP_SERIES_5',
        },
      },
      {
        default_label: '620 Gran Turismo',
        model: 'MAKE_BMW-MODELFAMILY_620_GRAN_TURISMO',
        model_group: {
          default_label: 'Series 6',
          group: 'MAKE_BMW-MODELFAMILYGROUP_SERIES_6',
        },
      },
      {
        default_label: '628',
        model: 'MAKE_BMW-MODELFAMILY_628',
        model_group: {
          default_label: 'Series 6',
          group: 'MAKE_BMW-MODELFAMILYGROUP_SERIES_6',
        },
      },
      {
        default_label: '630',
        model: 'MAKE_BMW-MODELFAMILY_630',
        model_group: {
          default_label: 'Series 6',
          group: 'MAKE_BMW-MODELFAMILYGROUP_SERIES_6',
        },
      },
      {
        default_label: '630 Gran Turismo',
        model: 'MAKE_BMW-MODELFAMILY_630_GRAN_TURISMO',
        model_group: {
          default_label: 'Series 6',
          group: 'MAKE_BMW-MODELFAMILYGROUP_SERIES_6',
        },
      },
      {
        default_label: '633',
        model: 'MAKE_BMW-MODELFAMILY_633',
        model_group: {
          default_label: 'Series 6',
          group: 'MAKE_BMW-MODELFAMILYGROUP_SERIES_6',
        },
      },
      {
        default_label: '635',
        model: 'MAKE_BMW-MODELFAMILY_635',
        model_group: {
          default_label: 'Series 6',
          group: 'MAKE_BMW-MODELFAMILYGROUP_SERIES_6',
        },
      },
      {
        default_label: '640',
        model: 'MAKE_BMW-MODELFAMILY_640',
        model_group: {
          default_label: 'Series 6',
          group: 'MAKE_BMW-MODELFAMILYGROUP_SERIES_6',
        },
      },
      {
        default_label: '640 Gran Coup\u00e9',
        model: 'MAKE_BMW-MODELFAMILY_640_GRAN_COUPE',
        model_group: {
          default_label: 'Series 6',
          group: 'MAKE_BMW-MODELFAMILYGROUP_SERIES_6',
        },
      },
      {
        default_label: '640 Gran Turismo',
        model: 'MAKE_BMW-MODELFAMILY_640_GRAN_TURISMO',
        model_group: {
          default_label: 'Series 6',
          group: 'MAKE_BMW-MODELFAMILYGROUP_SERIES_6',
        },
      },
      {
        default_label: '645',
        model: 'MAKE_BMW-MODELFAMILY_645',
        model_group: {
          default_label: 'Series 6',
          group: 'MAKE_BMW-MODELFAMILYGROUP_SERIES_6',
        },
      },
      {
        default_label: '650',
        model: 'MAKE_BMW-MODELFAMILY_650',
        model_group: {
          default_label: 'Series 6',
          group: 'MAKE_BMW-MODELFAMILYGROUP_SERIES_6',
        },
      },
      {
        default_label: '650 Gran Coup\u00e9',
        model: 'MAKE_BMW-MODELFAMILY_650_GRAN_COUPE',
        model_group: {
          default_label: 'Series 6',
          group: 'MAKE_BMW-MODELFAMILYGROUP_SERIES_6',
        },
      },
      {
        default_label: 'M6',
        model: 'MAKE_BMW-MODELFAMILY_M6',
        model_group: {
          default_label: 'Series 6',
          group: 'MAKE_BMW-MODELFAMILYGROUP_SERIES_6',
        },
      },
      {
        default_label: '725',
        model: 'MAKE_BMW-MODELFAMILY_725',
        model_group: {
          default_label: 'Series 7',
          group: 'MAKE_BMW-MODELFAMILYGROUP_SERIES_7',
        },
      },
      {
        default_label: '728',
        model: 'MAKE_BMW-MODELFAMILY_728',
        model_group: {
          default_label: 'Series 7',
          group: 'MAKE_BMW-MODELFAMILYGROUP_SERIES_7',
        },
      },
      {
        default_label: '730',
        model: 'MAKE_BMW-MODELFAMILY_730',
        model_group: {
          default_label: 'Series 7',
          group: 'MAKE_BMW-MODELFAMILYGROUP_SERIES_7',
        },
      },
      {
        default_label: '732',
        model: 'MAKE_BMW-MODELFAMILY_732',
        model_group: {
          default_label: 'Series 7',
          group: 'MAKE_BMW-MODELFAMILYGROUP_SERIES_7',
        },
      },
      {
        default_label: '735',
        model: 'MAKE_BMW-MODELFAMILY_735',
        model_group: {
          default_label: 'Series 7',
          group: 'MAKE_BMW-MODELFAMILYGROUP_SERIES_7',
        },
      },
      {
        default_label: '740',
        model: 'MAKE_BMW-MODELFAMILY_740',
        model_group: {
          default_label: 'Series 7',
          group: 'MAKE_BMW-MODELFAMILYGROUP_SERIES_7',
        },
      },
      {
        default_label: '745',
        model: 'MAKE_BMW-MODELFAMILY_745',
        model_group: {
          default_label: 'Series 7',
          group: 'MAKE_BMW-MODELFAMILYGROUP_SERIES_7',
        },
      },
      {
        default_label: '750',
        model: 'MAKE_BMW-MODELFAMILY_750',
        model_group: {
          default_label: 'Series 7',
          group: 'MAKE_BMW-MODELFAMILYGROUP_SERIES_7',
        },
      },
      {
        default_label: '760',
        model: 'MAKE_BMW-MODELFAMILY_760',
        model_group: {
          default_label: 'Series 7',
          group: 'MAKE_BMW-MODELFAMILYGROUP_SERIES_7',
        },
      },
      {
        default_label: 'M760',
        model: 'MAKE_BMW-MODELFAMILY_M760',
        model_group: {
          default_label: 'Series 7',
          group: 'MAKE_BMW-MODELFAMILYGROUP_SERIES_7',
        },
      },
      {
        default_label: 'ActiveHybrid 7',
        model: 'MAKE_BMW-MODELFAMILY_ACTIVEHYBRID_7',
        model_group: {
          default_label: 'Series 7',
          group: 'MAKE_BMW-MODELFAMILYGROUP_SERIES_7',
        },
      },
      {
        default_label: '840',
        model: 'MAKE_BMW-MODELFAMILY_840',
        model_group: {
          default_label: 'Series 8',
          group: 'MAKE_BMW-MODELFAMILYGROUP_SERIES_8',
        },
      },
      {
        default_label: '850',
        model: 'MAKE_BMW-MODELFAMILY_850',
        model_group: {
          default_label: 'Series 8',
          group: 'MAKE_BMW-MODELFAMILYGROUP_SERIES_8',
        },
      },
      {
        default_label: 'M850',
        model: 'MAKE_BMW-MODELFAMILY_M850',
        model_group: {
          default_label: 'Series 8',
          group: 'MAKE_BMW-MODELFAMILYGROUP_SERIES_8',
        },
      },
      {
        default_label: 'M8',
        model: 'MAKE_BMW-MODELFAMILY_M8',
        model_group: {
          default_label: 'Series 8',
          group: 'MAKE_BMW-MODELFAMILYGROUP_SERIES_8',
        },
      },
      {
        default_label: 'i3',
        model: 'MAKE_BMW-MODELFAMILY_I3',
        model_group: {
          default_label: 'Series i',
          group: 'MAKE_BMW-MODELFAMILYGROUP_SERIES_I',
        },
      },
      {
        default_label: 'i3s',
        model: 'MAKE_BMW-MODELFAMILY_I3S',
        model_group: {
          default_label: 'Series i',
          group: 'MAKE_BMW-MODELFAMILYGROUP_SERIES_I',
        },
      },
      {
        default_label: 'i4',
        model: 'MAKE_BMW-MODELFAMILY_I4',
        model_group: {
          default_label: 'Series i',
          group: 'MAKE_BMW-MODELFAMILYGROUP_SERIES_I',
        },
      },
      {
        default_label: 'i5',
        model: 'MAKE_BMW-MODELFAMILY_I5',
        model_group: {
          default_label: 'Series i',
          group: 'MAKE_BMW-MODELFAMILYGROUP_SERIES_I',
        },
      },
      {
        default_label: 'i7',
        model: 'MAKE_BMW-MODELFAMILY_I7',
        model_group: {
          default_label: 'Series i',
          group: 'MAKE_BMW-MODELFAMILYGROUP_SERIES_I',
        },
      },
      {
        default_label: 'i8',
        model: 'MAKE_BMW-MODELFAMILY_I8',
        model_group: {
          default_label: 'Series i',
          group: 'MAKE_BMW-MODELFAMILYGROUP_SERIES_I',
        },
      },
      {
        default_label: 'iX',
        model: 'MAKE_BMW-MODELFAMILY_IX',
        model_group: {
          default_label: 'Series i',
          group: 'MAKE_BMW-MODELFAMILYGROUP_SERIES_I',
        },
      },
      {
        default_label: 'iX1',
        model: 'MAKE_BMW-MODELFAMILY_IX1',
        model_group: {
          default_label: 'Series i',
          group: 'MAKE_BMW-MODELFAMILYGROUP_SERIES_I',
        },
      },
      {
        default_label: 'iX2',
        model: 'MAKE_BMW-MODELFAMILY_IX2',
        model_group: {
          default_label: 'Series i',
          group: 'MAKE_BMW-MODELFAMILYGROUP_SERIES_I',
        },
      },
      {
        default_label: 'iX3',
        model: 'MAKE_BMW-MODELFAMILY_IX3',
        model_group: {
          default_label: 'Series i',
          group: 'MAKE_BMW-MODELFAMILYGROUP_SERIES_I',
        },
      },
      {
        default_label: 'X1',
        model: 'MAKE_BMW-MODELFAMILY_X1',
        model_group: {
          default_label: 'Series X',
          group: 'MAKE_BMW-MODELFAMILYGROUP_SERIES_X',
        },
      },
      {
        default_label: 'X2',
        model: 'MAKE_BMW-MODELFAMILY_X2',
        model_group: {
          default_label: 'Series X',
          group: 'MAKE_BMW-MODELFAMILYGROUP_SERIES_X',
        },
      },
      {
        default_label: 'X3',
        model: 'MAKE_BMW-MODELFAMILY_X3',
        model_group: {
          default_label: 'Series X',
          group: 'MAKE_BMW-MODELFAMILYGROUP_SERIES_X',
        },
      },
      {
        default_label: 'X3 M',
        model: 'MAKE_BMW-MODELFAMILY_X3_M',
        model_group: {
          default_label: 'Series X',
          group: 'MAKE_BMW-MODELFAMILYGROUP_SERIES_X',
        },
      },
      {
        default_label: 'X4',
        model: 'MAKE_BMW-MODELFAMILY_X4',
        model_group: {
          default_label: 'Series X',
          group: 'MAKE_BMW-MODELFAMILYGROUP_SERIES_X',
        },
      },
      {
        default_label: 'X4 M',
        model: 'MAKE_BMW-MODELFAMILY_X4_M',
        model_group: {
          default_label: 'Series X',
          group: 'MAKE_BMW-MODELFAMILYGROUP_SERIES_X',
        },
      },
      {
        default_label: 'X5',
        model: 'MAKE_BMW-MODELFAMILY_X5',
        model_group: {
          default_label: 'Series X',
          group: 'MAKE_BMW-MODELFAMILYGROUP_SERIES_X',
        },
      },
      {
        default_label: 'X5 M',
        model: 'MAKE_BMW-MODELFAMILY_X5_M',
        model_group: {
          default_label: 'Series X',
          group: 'MAKE_BMW-MODELFAMILYGROUP_SERIES_X',
        },
      },
      {
        default_label: 'X6',
        model: 'MAKE_BMW-MODELFAMILY_X6',
        model_group: {
          default_label: 'Series X',
          group: 'MAKE_BMW-MODELFAMILYGROUP_SERIES_X',
        },
      },
      {
        default_label: 'X6 ActiveHybrid',
        model: 'MAKE_BMW-MODELFAMILY_ACTIVEHYBRID_X6',
        model_group: {
          default_label: 'Series X',
          group: 'MAKE_BMW-MODELFAMILYGROUP_SERIES_X',
        },
      },
      {
        default_label: 'X6 M',
        model: 'MAKE_BMW-MODELFAMILY_X6_M',
        model_group: {
          default_label: 'Series X',
          group: 'MAKE_BMW-MODELFAMILYGROUP_SERIES_X',
        },
      },
      {
        default_label: 'X7',
        model: 'MAKE_BMW-MODELFAMILY_X7',
        model_group: {
          default_label: 'Series X',
          group: 'MAKE_BMW-MODELFAMILYGROUP_SERIES_X',
        },
      },
      {
        default_label: 'XM',
        model: 'MAKE_BMW-MODELFAMILY_XM',
        model_group: {
          default_label: 'Series X',
          group: 'MAKE_BMW-MODELFAMILYGROUP_SERIES_X',
        },
      },
      {
        default_label: 'Z1',
        model: 'MAKE_BMW-MODELFAMILY_Z1',
        model_group: {
          default_label: 'Series Z',
          group: 'MAKE_BMW-MODELFAMILYGROUP_SERIES_Z',
        },
      },
      {
        default_label: 'Z3',
        model: 'MAKE_BMW-MODELFAMILY_Z3',
        model_group: {
          default_label: 'Series Z',
          group: 'MAKE_BMW-MODELFAMILYGROUP_SERIES_Z',
        },
      },
      {
        default_label: 'Z3 M',
        model: 'MAKE_BMW-MODELFAMILY_Z3_M',
        model_group: {
          default_label: 'Series Z',
          group: 'MAKE_BMW-MODELFAMILYGROUP_SERIES_Z',
        },
      },
      {
        default_label: 'Z4',
        model: 'MAKE_BMW-MODELFAMILY_Z4',
        model_group: {
          default_label: 'Series Z',
          group: 'MAKE_BMW-MODELFAMILYGROUP_SERIES_Z',
        },
      },
      {
        default_label: 'Z4 M',
        model: 'MAKE_BMW-MODELFAMILY_Z4_M',
        model_group: {
          default_label: 'Series Z',
          group: 'MAKE_BMW-MODELFAMILYGROUP_SERIES_Z',
        },
      },
      {
        default_label: 'Z8',
        model: 'MAKE_BMW-MODELFAMILY_Z8',
        model_group: {
          default_label: 'Series Z',
          group: 'MAKE_BMW-MODELFAMILYGROUP_SERIES_Z',
        },
      },
    ],
    vehicle_type: 'VEHICLETYPE_PASSENGER_CAR',
  },
];

export const makeModelWithRenaultMakesResponseMock: GetApiMakeModelWithMakeApiResponse = [
  {
    default_label: 'Renault',
    make: 'MAKE_RENAULT',
    models: [
      {
        default_label: 'Megane',
        model: 'MAKE_RENAULT-MODELFAMILY_MEGANE',
        model_group: null,
      },
      {
        default_label: 'Megane E-Tech Electric',
        model: 'MAKE_RENAULT-MODELFAMILY_MEGANE_E_TECH_ELECTRIC',
        model_group: null,
      },
      {
        default_label: 'Modus',
        model: 'MAKE_RENAULT-MODELFAMILY_MODUS',
        model_group: null,
      },
      {
        default_label: 'Nevada',
        model: 'MAKE_RENAULT-MODELFAMILY_NEVADA',
        model_group: null,
      },
    ],
    vehicle_type: 'VEHICLETYPE_PASSENGER_CAR',
  },
];
